import getLangLocale from 'I18n/utils/getLangLocale';
import { setPrimaryTracker } from 'usage-tracker-container';
import UsageTrackerContainer from './UsageTrackingContainer';
import { getTracker } from './getTracker';
import Logger from '../lib/Logger';
import { getSentryExtra } from '../error/getSentryExtra';
export const setupTracking = () => {
  try {
    getTracker().setProperties({
      lang: getLangLocale()
    });
    setPrimaryTracker(UsageTrackerContainer.getTracker());
  } catch (error) {
    Logger.getLogger('setupTracking').error('Error while setting up tracking', {
      extra: getSentryExtra(error)
    });
  }
};